module.exports = __webpack_public_path__ + "media/images/fantasy_logo_fr--dark-b3de5b84c0980a08e70c6cef0ecfbed6.svg";